/**
 * Tab slice — generic active-tab tracker for simple tabbed UI areas.
 * For the main Details Tab Strips use detailsTabStripsSlice instead, which
 * carries the full DTS metadata. This slice is for lightweight, local tab state
 * (e.g. secondary sub-panels) that don't need DTS-level context.
 */
import { createSlice } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from '../tab/constants'

export type TabState = {
    tabName?: string
}

const initialState: TabState = {
    tabName: '',
}

export const tabSlice = createSlice({
    name: `${SLICE_BASE_NAME}`,
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.tabName = action.payload
        },
    },
})

export const { setActiveTab } = tabSlice.actions
export default tabSlice.reducer
